"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newly = void 0;
exports.newly = {
    chrome: '141',
    edge: '141',
    firefox: '145',
    safari: '26.0',
    ios: '26.0',
};
exports.default = Object.entries(exports.newly).map(([b, v]) => `${b} >= ${v}`);
//# sourceMappingURL=newly.js.map